import styles from './link.module.scss';
import MaterialLink from '@mui/material/Link';

/* eslint-disable-next-line */
export interface LinkProps {
  children: any,
  // classes?: object,
  // color?: any,
  component?: any,
  sx?: any,
  onClick?: (...args: any[]) => void,
  // TypographyClasses?: object,
  underline?: 'always' | 'hover' | 'none',
  variant?: 'body1' | 'body2' | 'body3' | 'body4' | 'body5' | 'body6' | 'body7' | 'body8' | 'body9' | 'button' | 'caption' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'inherit' | 'overline' | 'subtitle1' | 'subtitle2' | 'subtitle3' | 'subtitle4',
  className?: string,
  href?: string,
  target?: string,
  title?: string,
  ['data-testid']?: string
}

export function Link(props: LinkProps) {
  return (
    <MaterialLink
      className={props.className}
      underline={props.underline}
      href={props.href}
      component={props.component}
      variant={props.variant}
      target={props.target}
      onClick={props.onClick}
      title={props.title}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialLink>
  );
}

export function GrayLink(props: LinkProps) {
  return (
    <MaterialLink {...props}
      className={`${props.className} ${styles.LinkGray}`}
    />
  );
}

export default Link;